export const normalizeInvoiceReference = (value) => String(value || '').trim();
export const earlyInvoiceErrorMessage = (error) => {
  const code = String(error?.message || '');
  if (code === '409') return 'An Unpaid invoice already exists for this period';
  if (code === 'timeout') return 'Request timed out; check Payment Due before retrying';
  if (code === 'invalid-response') return 'Invoice was created but the server returned an incomplete response';
  return 'Early Unpaid invoice failed';
};
